import React, { Component } from 'react';
import styled from 'styled-components';
import T from 'aegisv2/Text';
import { bool, func, string } from 'prop-types';
import { primaryMain, grayLight } from 'crehana-ui/styles/colors';

const SubItem = styled.div`
  padding: 4px 16px;
  margin: 8px 0;
  display: flex;
  transition: background-color 0.2s ease-in-out;
  &:last-child {
    margin-bottom: 0;
  }
  & > span {
    transition: color 0.2s ease-in-out;
  }

  @media (max-width: 1024px) {
    margin: 0px;
    border-bottom: 1px solid ${grayLight};
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 18px 16px 18px 16px;
    .flexBlock {
      display: flex;
      align-items: center;
      svg {
        margin-right: 8px;
      }
    }
  }

  ${({ disabled }) => {
    if (disabled) {
      return `
        opacity: 0.3;
        cursor: not-allowed !important;
      `;
    }

    return `
      @media (min-width: 1025px) {
        &:hover {
          background-color: rgba(0, 153, 255, 0.1);
          & > span { color: ${primaryMain} !important; }
        }
      }
      &.subSubItem-selected {
        background-color: ${primaryMain};
        & > span {
          color: #fff !important;
        }
      }
    `;
  }}
`;

const DesktopWrapper = styled.div`
  display: block;
  @media (max-width: 1024px) {
    display: none;
  }
`;

class FilterItem extends Component {
  shouldComponentUpdate(nextProps) {
    const { disabled, isSelected } = this.props;

    return (
      disabled !== nextProps.disabled || isSelected !== nextProps.isSelected
    );
  }

  render() {
    const { isSelected, disabled, onClick, name } = this.props;

    return (
      <div>
        <DesktopWrapper>
          <SubItem
            className={isSelected ? 'subSubItem-selected' : ''}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
          >
            <T xs>{name}</T>
          </SubItem>
        </DesktopWrapper>
      </div>
    );
  }
}

FilterItem.defaultProps = {
  disabled: false,
};

FilterItem.propTypes = {
  name: string.isRequired,
  onClick: func.isRequired,
  isSelected: bool.isRequired,
  disabled: bool,
};

export default FilterItem;
